












import vue from "vue";
import { VUEX_EXERCISE_ACTION_NAMES, VUEX_EXERCISE_NAMESPACE } from "@tt-app/constants";

const { SETTINGS_POPUP_CLOSE } = VUEX_EXERCISE_ACTION_NAMES;

interface Computed {
  open: boolean;
}

export default vue.extend<any, any, Computed, any>({
  name: "ExerciseMiniSettings",

  methods: {
    handleClick(event: any) {
      const miniSettingsSpan = this.$refs["mini-settings"];

      const cardHeight = miniSettingsSpan.offsetHeight;
      const cardWidth = miniSettingsSpan.offsetWidth;

      const clickLocationOffsetX = event.offsetX;
      const clickLocationOffsetY = event.offsetY;

      const clickUnderWidth = clickLocationOffsetX < 0;
      const clickOverWidth = clickLocationOffsetX >= cardWidth;

      const clickUnderHeight = clickLocationOffsetY < 0;
      const clickOverHeight = clickLocationOffsetY >= cardHeight;

      const clickOutsideWidth = clickUnderWidth || clickOverWidth;
      const clickOutsideHeight = clickUnderHeight || clickOverHeight;

      if (clickOutsideHeight || clickOutsideWidth) {
        this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${SETTINGS_POPUP_CLOSE}`);
      }
    }
  },

  computed: {
    open() {
      return this.$store.state.exercise.settings.modal.open;
    }
  }
});
